<template>
  <card
    :tight="tight"
    :isFluid="card.isFluid"
    :size="card.size"
    :padBottom="card.padBottom"
    :height="card.height"
    :width="card.width"
    :contentStyle="card.contentStyle"
    :backgroundPosition="card.backgroundPosition"
    :backgroundRepeat="card.backgroundRepeat"
    :backgroundImage="card.backgroundImage"
    :backgroundColor="card.backgroundColor"
    :backgroundSize="card.backgroundSize"
    :label="card.label"
    :header="card.header"
    :subHeader="card.subHeader">
    <template v-if="card.customContent">
      <div v-html="card.customContent" />
      <slot></slot>
    </template>
    <template v-else>
      <card-image :image="card.image"/>
      <card-label :label="card.label"/>
      <card-header :header="card.header"/>
      <card-sub-header :subHeader="card.subHeader"/>
      <card-button :button="card.button"/>
      <slot></slot>
    </template>
  </card>
</template>
<script>
import Card from '../Card'
import CardLabel from '../CardLabel'
import CardImage from '../CardImage'
import CardHeader from '../CardHeader'
import CardButton from '../CardButton'
import CardSubHeader from '../CardSubHeader'

export default {
  name: 'solo-card',
  props: {
    card: {
      type: Object,
      required: true
    },
    tight: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Card,
    CardLabel,
    CardImage,
    CardHeader,
    CardButton,
    CardSubHeader
  }
}
</script>
